import Immutable from 'immutable';

import {
  START_LOGIN,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  INVALID_CREDENTIALS_ERROR,
  NO_ACTIVE_CAMPAIGN_ERROR,
  AUTH_EXPIRED_ERROR,
  LOGOUT_SUCCESS
} from '../actions/login';

const initialState = Immutable.fromJS({
  status: 'not attempted'
});

export default function(state = initialState, action) {
  switch (action.type) {
    case START_LOGIN:
      return state.set('status', 'pending');
    case LOGIN_SUCCESS:
      return state.mergeDeep({
        status: 'ok'
      });
    case LOGIN_ERROR:
    case INVALID_CREDENTIALS_ERROR:
    case NO_ACTIVE_CAMPAIGN_ERROR:
      return state.merge({
        status: 'error',
        err: action.error
      });
    case AUTH_EXPIRED_ERROR:
      return state.merge({
        status: 'expired'
      });
    case LOGOUT_SUCCESS:
      return initialState;
    default:
      return state;
  }
}

/* Selectors */

export function getLoginStatus(state) {
  return state && state.getIn(['login', 'status']);
}

export function isLoginPending(state) {
  return getLoginStatus(state) === 'pending';
}
